import DateUtil from "../../../utils/DateUtil";
import TimezoneUtil from "../../../utils/TimezoneUtil";
import AuthService from "../../../services/auth-service/AuthService";

const isPatientOver18YearsOld = (birthday) => {
    const {uaeSelected, kuwaitSelected} = AuthService.getSelectedClinicCountriesInfo();
    if (kuwaitSelected && uaeSelected)
        return birthday && DateUtil.getAge(birthday) >= 18;
    else if (kuwaitSelected && !uaeSelected)
        return birthday && DateUtil.getAge(birthday) >= 21;
    else // We assumed that uae is the default
        return birthday && DateUtil.getAge(birthday) >= 18;
}

const getWitnessAgeText = () => {
    const {uaeSelected, kuwaitSelected} = AuthService.getSelectedClinicCountriesInfo();
    if (!kuwaitSelected && uaeSelected)
        return "18";
    else if (kuwaitSelected && !uaeSelected)
        return "21";
    else // If both clinics selected
        return "18";
}

// signature timestamps render in the clinic time zone, not the viewer's browser zone
const formatSignatureDateTime = (date) => {
    return DateUtil.formatTzDate(date, TimezoneUtil.getClinicTimeZone(), 'MMMM DD YYYY, h:mm:ss a');
}

const formatSignatureDate = (date) => {
    return DateUtil.formatTzDate(date, TimezoneUtil.getClinicTimeZone(), 'MMMM DD, YYYY');
}

export default {isPatientOver18YearsOld, getWitnessAgeText, formatSignatureDateTime, formatSignatureDate};
